<template>
  <div class="agent-overview-page">
    <div class="head_area">
      <div class="leftImg">
        <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
      </div>
      <span class="head_text">代理总览</span>
      <span class="right_menu"></span>
    </div>
    <div class="search-box">
      <div class="search-item">
        <div class="select-time-box" @click="show_start_time = true">
          <template v-if="params.start_date.length > 0">
            <span>{{params.start_date}}</span>
            <div class="close-btn" @click.stop="params.start_date = ''">
              <van-icon name="close" size=".45rem" color="#cccccc" />
            </div>
          </template>

          <span class="placeholder" v-else>选择开始日期</span>

        </div>
        <div class="line">~</div>
        <div class="select-time-box" @click="selectTime()">
          <template v-if="params.end_date.length > 0">
            <span>{{params.end_date}}</span>
            <div class="close-btn" @click.stop="params.end_date = ''">
              <van-icon name="close" size=".45rem" color="#cccccc" />
            </div>
          </template>
          <span class="placeholder" v-else>选择结束日期</span>
        </div>
        <div class="search-btn" @click="initData()">搜索</div>
      </div>
    </div>
    <div class="content">
      <div class="info-list">
        <div class="info-item">
          <div class="label">团队总人数:</div>
          <div class="value">{{ info.team_total_members }}</div>
        </div>
        <div class="info-item">
          <div class="label">团队总彩金:</div>
          <div class="value">{{ info.team_bonus }}</div>
        </div>
<!--        <div class="info-item">-->
<!--          <div class="label">团队总回水:</div>-->
<!--          <div class="value">{{ 0 }}</div>-->
<!--        </div>-->
        <div class="info-item">
          <div class="label">团队总充值:</div>
          <div class="value">{{ info.team_total_recharge }}</div>
        </div>
        <div class="info-item">
          <div class="label">团队总输赢:</div>
          <div class="value">{{ info.team_total_winloss }}</div>
        </div>
        <div class="info-item">
          <div class="label">团队总投注:</div>
          <div class="value">{{ info.team_total_bet }}</div>
        </div>
        <div class="info-item">
          <div class="label">团队纯利:</div>
          <div class="value">{{ info.team_net_profit }}</div>
        </div>
        <div class="info-item">
          <div class="label">团队福利:</div>
          <div class="value">{{ info.team_welfare }}</div>
        </div>
        <div class="info-item">
          <div class="label">新注册人数:</div>
          <div class="value">{{ info.new_registers }}</div>
        </div>
        <div class="info-item">
          <div class="label">首充人数:</div>
          <div class="value">{{ info.first_recharge_count }}</div>
        </div>
        <div class="info-item">
          <div class="label">团队返水:</div>
          <div class="value">{{ info.team_rebate }}</div>
        </div>
        <div class="info-item">
          <div class="label">团队拥金返水:</div>
          <div class="value">{{ info.team_commission_rebate }}</div>
        </div>
<!--        <div class="info-item">-->
<!--          <div class="label">六合总投注:</div>-->
<!--          <div class="value">{{ 0 }}</div>-->
<!--        </div>-->
        <div class="info-item">
          <div class="label">六合盈亏:</div>
          <div class="value">{{ info.six_party_winloss }}</div>
        </div>
      </div>
    </div>

    <!--    开始时间    -->
    <van-calendar v-model="show_start_time" @confirm="onConfirm"
                  color="#1989fa"
                  :min-date="new Date(1900, 0, 1)"
                  :max-date="current_date" />
    <!--    结束时间    -->
    <van-calendar v-model="show_end_time" @confirm="onConfirm"
                  color="#1989fa"
                  v-if="params.start_date.length > 0"
                  :min-date="new Date(params.start_date)"/>
  </div>
</template>

<script>
import {translateText, getCurrentDay, formatDate} from "../../common/utils";

export default {
  name: 'agent-info',
  data(){
    return {
      params: {
        start_date: '',   // 开始时间
        end_date: '',    // 结束时间
      },
      total: 0,
      current_date: new Date(),
      date: getCurrentDay(),
      show_start_time: false,
      show_end_time: false,
      loading: false,
      info: {}
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    back(){
      window.history.go(-1)
    },
    initData() {
      this.getInfo()
    },
    selectTime() {
      if(this.params.start_date.length === 0){
        this.showTost(0, "请先选择开始时间")
        return;
      }
      this.show_end_time = true
    },
    onConfirm(date) {
      if(this.show_start_time){
        this.show_start_time = false
        this.params.start_date = formatDate(date)
        this.params.end_date = ''
      }else {
        this.show_end_time = false
        this.params.end_date = formatDate(date)
      }
    },
    async showTost(type, title) {
      // const message = await translateText([title]);
      this.$parent.showTost(type, title);
    },
    getInfo(){
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/overview', {
          ...this.params
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            this.info = res.data
          }
          this.$parent.hideLoading()
        })
        .catch(res => {
          this.$parent.hideLoading()
        });
    }

  },
}
</script>

<style scoped lang="scss">
.agent-overview-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction:column;
  overflow: hidden;
  background: #F1F1F1;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    background: linear-gradient( 90deg, #3A8AFF 0%, #89AAFF 100%);
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.43rem;
      font-weight: bold;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .search-box {
    padding: 0.24rem .36rem 0;
    .search-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.24rem;
      .select-time-box {
        width: 3.6rem;
        height: 0.77rem;
        background: #fff;
        border-radius: .5rem;
        padding: 0 0.27rem;
        font-size: 0.24rem;
        line-height: .35rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        position: relative;
        .close-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: .1rem;
        }
        .placeholder {
          color: #999999;
        }
      }
      .line {
        margin: 0 .15rem;
      }
      .input-box {
        display: flex;
        align-items: center;
        padding: 0 0.3rem 0 0.5rem;
        background: #fff;
        height: 0.77rem;
        flex: 1;
        border-radius: .5rem;
        input {
          flex: 1;
          height: 100%;
          outline: none;
          background: transparent;
          border: none;
          font-size: 0.29rem;
          &::-webkit-input-placeholder {
            color: #999999;
          }
        }
      }
      .search-btn {
        flex-shrink: 0;
        height: 0.75rem;
        line-height: 0.75rem;
        padding: 0 .19rem;
        background: linear-gradient( 90deg, #02BCEE 0%, #0B76FD 100%);
        border-radius: .37rem;
        font-size: 0.24rem;
        color: #fff;
        margin-left: .14rem;
        min-width: 1rem;
        text-align: center;
      }
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    z-index: 2;
    padding: .24rem .36rem;
    .info-list {
      background: #FFFFFF;
      border-radius: .24rem;
      padding: 0 .24rem;
      overflow: hidden;
      .info-item {
        height: .9rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 0.02rem solid #F0F0F0;
        &:last-child {
          border-bottom: none;
        }
        .label {
          color: #666666;
          font-size: 0.29rem;
          width: 3.4rem;
        }
        .value {
          flex: 1;
          font-size: 0.34rem;
          font-family: Gilroy, Gilroy;
          text-align: right;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agent/overview.vue